import { CONTENT_WIDTH_MID_CENTERED_2_COLUMN } from '@sleepstation/metrics-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import BreakoutModule from '../BreakoutModule'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BreakoutModuleMid = (props) => (
  <BreakoutModule {...props} maxWidths={CONTENT_WIDTH_MID_CENTERED_2_COLUMN} />
)

BreakoutModuleMid.propTypes = {
  hasBottomBorder: PropTypes.bool,
  hasGradient: PropTypes.bool,
}

BreakoutModuleMid.defaultProps = {
  hasBottomBorder: true,
  hasGradient: true,
}

export default BreakoutModuleMid
